// FactsBlock: what Otto may say about Otto's Office when asked ("who is
// Ruby", "when does it arrive"). Anything not in here, Otto does not know
// (design 5.7; the Sept 1 rule that company knowledge lives in its own block).
import { z } from "zod";
import { DraftLabel, behaviorText } from "./common";

export const FactsBlock = z.object({
  draft_label: DraftLabel,
  /** About 700 tokens, 800 at most (design 5.7); 8000 characters is the hard ceiling. */
  text: behaviorText(8000),
  /** What Otto says when asked something the block does not cover. */
  unknown_answer: behaviorText(300),
});
export type FactsBlock = z.infer<typeof FactsBlock>;
